import axios from "./axios"

const getEvents = async (data) => {
	return await axios.get(`/event`, data).then((data) => {
		return data
	})
}

const saveEvent = async (data, id) => {
	return id
		? await axios.put(`/event/${id}`, data).then((data) => {
				return data
		  })
		: await axios.post(`/event`, data).then((data) => {
				return data
		  })
}

const deleteEvent = async (id) => {
	return await axios.delete(`/event/?event_id=${id}`).then((data) => {
		return data
	})
}

export const eventServices = {
	getEvents,
	saveEvent,
	deleteEvent,
}
